export enum API_REQUEST_HEADER {
    current_organisation_id = 'Current-Organisation-Id',
    firebase_token = 'Firebase-Token',
    trace_id = 'X-Trace-Id',
    form_id = 'X-Form-Id',
    app_version = 'X-App-Version',
}
